<template>
  <div class="productConfigurator">
    <SetConfigurator v-if="isSet" v-model="selectedImages" :product="product" @addedToBasket="addedToBasket" @error="onError"/>
    <ImageBatchSelector v-else-if="needsBatchSelection" v-model="selectedImages" :product="product" @addedToBasket="addedToBasket" @error="onError"/>
    <SingleConfigurator v-else v-model="selectedImages" :product="product" @addedToBasket="addedToBasket" @error="onError"/>
  </div>

</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";
import {ConfiguredImageDto, ImageFilterDto, ImageRequirementDto, ProductDto, ProductTypeDto} from "@swagger";
import ImageBatchSelector from "@/components/product-configuration/ImageBatchSelector.vue";
import PersonSelector from "@/components/product-configuration/PersonSelector.vue";
import SetConfigurator from "@/components/product-configuration/SetConfigurator.vue";
import SingleConfigurator from "@/components/product-configuration/SingleConfigurator.vue";
import TypeEnum = ImageRequirementDto.TypeEnum;

@Component({
  components: {
    SingleConfigurator,
    ImageBatchSelector,
    SetConfigurator,
    PersonSelector,
    ImageSelectionRow: ImageBatchSelector
  }
})
export default class ProductConfigurator extends BasicComponent {

  @Prop(Object) product: ProductDto;

  selectedImages: ConfiguredImageDto[] = [];

  get isSet(): boolean {
    // Use productType instead of the requirement count so that a SET with a single
    // sub-product (or a single ProductContent with amount=1) also goes through the
    // SetConfigurator. Otherwise SingleConfigurator would send the SET's id as the
    // ConfiguredImage.productId, which is semantically wrong and breaks the admin
    // order view and print mapping (see OrderMapper.mapOrderItemToConfigurationDto).
    return this.product.productType === ProductTypeDto.SET;
  }

  get needsBatchSelection(): boolean {
    return this.product.imageRequirements[0].type === TypeEnum.ALLOFPERSON;
  }

  get availableFilters() {
    return Object.keys(ImageFilterDto).map(id => {
      return {
        id: id,
        name: this.$t(`FILTER_NAME_${id}`)
      }
    });
  }

  addedToBasket(): void {
    this.$emit("addedToBasket");
  }

  onError(error: string): void {
    this.$emit("error", error);
  }

}

</script>
<style lang="scss" scoped>

</style>
<style lang="scss">
.productConfigurator {
  max-height: 100%;

  .title {
    display: block;
    color: black;
    text-align: center;
    margin-bottom: 15px;
  }

  p {
    text-align: center;
  }

}
</style>